import React from 'react'

import { Grid } from 'semantic-ui-react'

const Hero = (props) => (
  <div {...props}>
    <Grid>
      {props.images.map((image, i) => (
        <Grid.Column key={i}>
          {image}
        </Grid.Column>
      ))}
    </Grid>
  </div>
)

Hero.defaultProps = {
  images: [],
}

export default Hero
